import React, {forwardRef, useImperativeHandle, useRef} from 'react';
import PropTypes from 'prop-types';
import {useAsync} from 'react-use';

import {useAppStore} from '@/page/app/context';
import SendArea from '@/page/app/MsgSendPage/SendArea';
import {getApp} from '@/api/apps';
import {useAuthStore} from '@/context/auth';

const ExtraNewsSendAreaWrapper = forwardRef(({appId}, ref) => {
    const SendAreaRef = useRef();
    const [
        {
            user: {id: userId},
        },
    ] = useAuthStore();
    const [, dispatch] = useAppStore();
    useAsync(() => {
        return getApp(appId).then(({data}) => {
            dispatch(['initApp', {app: data, userId, roleType: 'app_mgr'}]);
            return data;
        });
    }, [appId]);
    // console.log(value, loading);

    useImperativeHandle(ref, () => ({
        getData: () => SendAreaRef.current.getData(),
        clear: () => SendAreaRef.current.clear(),
    }));

    return <SendArea ref={SendAreaRef} appId={appId} />;
});

ExtraNewsSendAreaWrapper.displayName = 'ExtraNewsSendAreaWrapper';

ExtraNewsSendAreaWrapper.propTypes = {
    appId: PropTypes.string.isRequired,
};

export default ExtraNewsSendAreaWrapper;
